// extracted by mini-css-extract-plugin
export default {"container":"InformationSystemsAcceptableUsePolicyPage_container__PadD1"};